import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { enviroments } from 'utils/constants';
import { getLocalStorageLanguage } from 'utils/utils';

const CURRENT_LANGUAGE = getLocalStorageLanguage();

export const linesServiceApi = createApi({
  reducerPath: 'linesServiceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: enviroments.endPoint,
    prepareHeaders: (headers, { getState, endpoint }) => {
      headers.set(
        'Authorization',
        'Bearer ' + JSON.parse(localStorage.getItem('userAccountInformation') || '{}').bearerToken,
      );
      return headers;
    },
  }),
  endpoints: (builder) => ({
    GetLines: builder.query<any, void>({
      query: () => 'agency/lines/',
    }),
    GetSubLines: builder.query<any, number>({
      query: (id) => `agency/lines/${id}/sublines`,
    }),
    GetLineShape: builder.query<any, number>({
      query: (id) => `agency/lines/${id}/shape`,
    }),
    GetLineShapeGeneric: builder.query<any, number>({
      query: (id) => `agency/lines/${id}/shapes-generic`,
    }),
    GetLineShapeTrip: builder.query<any, any>({
      query: ({ id, tripId }) =>
        !tripId ? `agency/lines/${id}/shape` : `agency/lines/${id}/shape?tripId=${tripId}`,
    }),
    GetScheduleBySubline: builder.query<any, any>({
      query: ({ subLineId, language = CURRENT_LANGUAGE }) =>{
        return `schedule/?sublineCode=${subLineId}&locale=${language}`;
      },
    }),
    GetLineShapeOverlapping: builder.query<any, any>({
      query: () => 'agency/lines/overlapping',
    }),
    GetLineStop: builder.query<any, number>({
      query: (id) => `agency/lines/${id}/stops?isLine=0&isLineNearStop=0&both=1`,
    }),
    GetLineStopWithTrip: builder.query<any, any>({
      query: ({ id, tripId }) => `agency/lines/${id}/stops?tripId=${tripId}`,
    }),
    GetLineDirections: builder.query<any, number>({
      query: (id) => `agency/lines/${id}/directions`,
    }),
    GetSubLineDirections: builder.query<any, number>({
      query: (id) => `agency/lines/directions-subline?subLineId=${id}`,
    }),
    GetNearStops: builder.query<any, any>({
      query: ({ latitude, longitude }) =>
        `/agency/lines/near-stop?latitude=${latitude}&longitude=${longitude}`,
    }),
    GetLinesBothTypesStopsTrip: builder.query<any, any>({
      query: ({ id, tripId }) =>
        `agency/lines/${id}/stops?tripId=${tripId}&isLine=0&isLineNearStop=0&both=1`,
    }),
    GetLinesBothTypesStops: builder.query<any, any>({
      query: (id) => `agency/lines/${id}/stops?isLine=0&isLineNearStop=0&both=1`,
    }),
  }),
});

export const {
  useLazyGetLinesQuery,
  useLazyGetSubLinesQuery,
  useLazyGetLineShapeQuery,
  useLazyGetLineShapeGenericQuery,
  useLazyGetLineShapeOverlappingQuery,
  useLazyGetLineStopQuery,
  useLazyGetLineDirectionsQuery,
  useLazyGetSubLineDirectionsQuery,
  useLazyGetLineStopWithTripQuery,
  useLazyGetLineShapeTripQuery,
  useLazyGetNearStopsQuery,
  useLazyGetLinesBothTypesStopsTripQuery,
  useLazyGetLinesBothTypesStopsQuery,
  useLazyGetScheduleBySublineQuery
} = linesServiceApi;
